/**
 * Colour and size tokens of the Site lookup screen only: the global MUI theme is unchanged.
 */
export const siteLookupTokens = {
  color: {
    primary: '#4F46E5',
    link: '#4338CA',
    text: { primary: '#111827', secondary: '#4B5563', muted: '#6B7280' },
    border: '#E5E7EB',
    inputBorder: '#D1D5DB',
    tag: '#F3F4F6',
    warning: '#9A3412',
    chip: {
      activeBackground: '#EEF2FF',
      activeBorder: '#C7D2FE',
      activeText: '#3730A3',
      openRing: '#A5B4FC',
    },
    availability: {
      available: { background: '#DCFCE7', text: '#166534' },
      busy: { background: '#FFEDD5', text: '#9A3412' },
      unavailable: { background: '#FEE2E2', text: '#991B1B' },
      unknown: { background: '#F3F4F6', text: '#374151' },
    },
    /** Real-time reliability score; every text colour is ≥ 4.5:1 against its background */
    reliability: {
      poor: { background: '#D32F2F', text: '#FFFFFF' },
      low: { background: '#F57C00', text: '#111827' },
      fair: { background: '#FBC02D', text: '#111827' },
      good: { background: '#66BB6A', text: '#111827' },
      excellent: { background: '#1B5E20', text: '#FFFFFF' },
      na: { background: '#E0E0E0', text: '#111827' },
    },
    /** Real-time dot of the source control */
    live: '#16A34A',
    areaSummary: '#F5F5FF',
    rowHover: '#F9FAFB',
    segmented: { track: '#F3F4F6', active: '#FFFFFF' },
    chart: {
      /** ≥ 3:1 against white; the current hour stands out darker */
      bar: '#6366F1',
      barCurrent: '#312E81',
      line: '#4F46E5',
      grid: '#E5E7EB',
    },
    /** Area Summary charging price chart: median line over the middle 50% band, on the Area Summary background */
    priceChart: {
      median: '#534AB7',
      band: '#7F77DD',
      bandOpacity: 0.28,
      /** gridlines and tooltip divider */
      grid: 'rgba(38,33,92,0.12)',
      cursor: 'rgba(38,33,92,0.35)',
      tooltipBorder: 'rgba(38,33,92,0.18)',
      tooltipBackground: '#FFFFFF',
      text: { primary: '#1F1E2E', secondary: '#5F5D75', muted: '#7A7890' },
    },
  },
  size: {
    /** search field and Export button */
    controlHeight: 44,
    controlRadius: '10px',
    chipHeight: 34,
    chipRadius: '9999px',
    tagFontSize: 12,
    listMinWidth: 380,
    /** list header line and top of the station sheet: same height in every permission case */
    sourceControlHeight: 30,
    rowLogo: 40,
    sheetLogo: 44,
    listMaxWidth: 460,
  },
} as const;
